module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av250-21105849f18738a3bd2ebf75a08d053b.jpg";